var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Injector, OnInit } from '@angular/core';
import { MobileBasePage } from 'src/app/core/base/mobile-base-page';
import { NavParams } from '@ionic/angular';
var LanguageChoice = /** @class */ (function (_super) {
    __extends(LanguageChoice, _super);
    function LanguageChoice(injector, navParams) {
        var _this = _super.call(this, injector) || this;
        _this.injector = injector;
        _this.navParams = navParams;
        _this.inputs = _this.navParams.get('inputs');
        _this.lang = _this.navParams.get('lang');
        _this.callBack = _this.navParams.get('callBack');
        console.log(_this.inputs);
        return _this;
    }
    LanguageChoice.prototype.ngOnInit = function () {
    };
    LanguageChoice.prototype.clickedLanguage = function (value) {
        var _this = this;
        this.popoverController.dismiss();
        if (value === this.lang)
            return;
        this.t.use(value).subscribe(function (data) {
            _this.configService.setLocale(value);
            if (value === 'zh')
                document.documentElement.setAttribute('lang', 'zh-Hant');
            else if (value === 'zh-cn') {
                document.documentElement.setAttribute('lang', 'zh-Hans');
            }
            else {
                document.documentElement.setAttribute('lang', value);
            }
            _this.callBack(value);
        });
    };
    return LanguageChoice;
}(MobileBasePage));
export { LanguageChoice };
